import { array, object, string } from 'yup';

import { getMaxLengthErrMsg, getMinLengthErrMsg, validationErrMessages } from '@constants/validationConstants';
import { MAX_2_LENGTH, MAX_10_LENGTH, MAX_80_LENGTH, MAX_1000_LENGTH } from '@constants/validationMessages';

export const getSchema = () => object({
	projectName: string()
		.trim()
		.default('')
		.max(MAX_80_LENGTH, getMaxLengthErrMsg('Project Name', MAX_80_LENGTH))
		.required(validationErrMessages.projectName),
	projectCode: string()
		.trim()
		.default('')
		.min(MAX_2_LENGTH, getMinLengthErrMsg('Project Code', MAX_2_LENGTH))
		.max(MAX_10_LENGTH, getMaxLengthErrMsg('Project Code', MAX_10_LENGTH))
		.required(validationErrMessages.projectCode),
	status: object()
		.nullable()
		.required(validationErrMessages.status),
	workflow: object()
		.nullable()
		.required(validationErrMessages.workflow),
	description: string()
		.trim()
		.default('')
		.max(MAX_1000_LENGTH, getMaxLengthErrMsg('Project Description', MAX_1000_LENGTH)),
	admins: array().nullable(),
	members: array().nullable(),
});
